import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state () {
      return {
        count: 0,
        screenWidth:document.documentElement.clientWidth, //屏幕宽度
      }
    },
    mutations: {
      increment (state) {
        state.count++
      }
    }
  })

  export default store